import React from "react";
import BasicListPanel from './basicListPanel';

export default class ListPanel extends React.Component {
    static defaultProps = {
        columns: {
            xl: 3,
            lg: 3,
            md: 2,
            sm: 1,
            xs: 1,
        },
        index: -1,
        detail: null,
    }

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);

        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    render() {
        return (
            <BasicListPanel columns={this.state.columns} index={this.props.index} detail={this.props.detail}>
                {this.props.children}
            </BasicListPanel>
        );
    }

    onResize = () => {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const { columns } = this.props;
        let cols = columns.xs || 1;
        if (width >= 1200) {
            cols = columns.xl || columns.lg || columns.md || columns.sm || columns.xs || 1;
        } else if (width >= 992) {
            cols = columns.lg || columns.md || columns.sm || columns.xs || 1;
        } else if (width >= 768) {
            cols = columns.md || columns.sm || columns.xs || 1;
        } else if (width >= 576) {
            cols = columns.sm || columns.xs || 1;
        }

        this.setState({ columns: cols });
    }
}